import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import useStyles from './NotFound.styles';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import { useHistory } from 'react-router-dom';
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded';
const NotFound = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Box className={styles.container}>
      <Box className={styles.messageContainer}>
        <Typography variant="h1" color="error">
          440
        </Typography>
        <Typography variant="h5" color="error">
          {t(tPaths.notFound.notFound)}
        </Typography>
        <Button
          variant="text"
          startIcon={<ArrowBackRoundedIcon color="primary" />}
          onClick={history.goBack}
        >
          <Typography variant="h6" color="primary">
            {t(tPaths.global.goBack)}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
